var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.873 23.5a3.74872 3.74872 0 0 1 -2.6689-1.10547 3.69562 3.69562 0 0 1 -.99512-3.5664 1.65683 1.65683 0 0 0 -2.0371-2.0376 3.69321 3.69321 0 0 1 -3.56348-.99073 3.78047 3.78047 0 0 1 -.00293-5.3408l8.85353-8.85353a3.86416 3.86416 0 0 1 5.33692 0 3.69563 3.69563 0 0 1 .99508 3.56641 1.663 1.663 0 0 0 .42578 1.61181l.001.00049a1.658 1.658 0 0 0 1.61036.42529 3.69414 3.69414 0 0 1 3.56347.99073 3.78047 3.78047 0 0 1 .00293 5.34082l-8.85354 8.85351a3.74815 3.74815 0 0 1 -2.668 1.10547zm-5.26558-8.76807a3.6561 3.6561 0 0 1 3.53125 4.624 1.68894 1.68894 0 0 0 .47656 1.6206 1.81311 1.81311 0 0 0 2.51172.00391l8.85352-8.85344a1.77647 1.77647 0 0 0 0-2.50879 1.68664 1.68664 0 0 0 -1.625-.479 3.65771 3.65771 0 0 1 -4.49414-4.49521 1.68894 1.68894 0 0 0 -.47656-1.6206 1.81311 1.81311 0 0 0 -2.51177-.00387l-8.85347 8.85347a1.77649 1.77649 0 0 0 0 2.50879 1.68539 1.68539 0 0 0 1.625.479 3.6717 3.6717 0 0 1 .96289-.12886z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 16a.99974.99974 0 0 1 -1-1v-6a1 1 0 0 1 2 0v6a.99974.99974 0 0 1 -1 1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.172,
    cy: 11.646,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.828,
    cy: 12.354,
    r: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.2f8ea1790793ee9d3a9685528edd4c72.svg";
export { ForwardRef as ReactComponent };